import React from "react";
import { Link, useParams } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import ScrollToTop from "@/components/ScrollToTop";
import { BLOG_POSTS, HOMESTAY } from "@/lib/data";
import { ArrowLeft } from "lucide-react";

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);

  React.useEffect(() => {
    if (post) document.title = `${post.title} | Mrinmaya vacation home`;
  }, [post]);

  if (!post) {
    return (
      <div className="bg-mrn-bg min-h-screen">
        <Header />
        <main className="pt-40 pb-24 text-center px-6">
          <h1 className="headline-display text-4xl text-mrn-wood">Guide not found.</h1>
          <Link to="/blog" className="mrn-pill mrn-pill-outline mt-8 inline-flex">
            Back to Journal
          </Link>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="bg-mrn-bg min-h-screen" data-testid="blog-post-page">
      <Header />
      <main className="pt-28">
        <article>
          <div className="relative h-[52vh] md:h-[70vh] overflow-hidden">
            <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/40 to-mrn-bg" />
            <div className="absolute inset-x-0 bottom-0 max-w-4xl mx-auto px-6 md:px-10 pb-10 md:pb-14">
              <Link to="/blog" className="inline-flex items-center gap-1 text-mrn-cream text-xs uppercase tracking-widest">
                <ArrowLeft size={14} /> All guides
              </Link>
              <h1 className="mt-5 headline-display text-mrn-cream text-4xl md:text-6xl max-w-3xl">
                {post.title}
              </h1>
              <div className="mt-5 text-mrn-sand text-xs uppercase tracking-widest">
                {post.date} · {post.readTime}
              </div>
            </div>
          </div>

          <div className="max-w-3xl mx-auto px-6 md:px-10 py-16">
            {post.content.map((para, i) => (
              <p key={i} className="mt-6 text-lg leading-relaxed text-mrn-wood-soft first:mt-0">
                {para}
              </p>
            ))}

            <div className="mt-12 flex flex-wrap gap-2">
              {post.tags.map((t) => (
                <span
                  key={t}
                  className="text-xs uppercase tracking-widest text-mrn-terracotta border border-mrn-terracotta/40 rounded-full px-3 py-1"
                >
                  {t}
                </span>
              ))}
            </div>

            <div className="mt-16 rounded-2xl bg-mrn-wood text-mrn-cream p-8 md:p-10">
              <h3 className="font-display text-3xl">Stay at Mrinmaya</h3>
              <p className="mt-3 text-mrn-sand max-w-lg">
                A 3-bedroom rustic villa 90 minutes from Bangalore. Perfect for a weekend plan
                like this one.
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <a href="/#inquiry" className="mrn-pill mrn-pill-primary">Enquire for dates</a>
                <a
                  href={HOMESTAY.contact.airbnb_url}
                  target="_blank"
                  rel="noreferrer"
                  className="mrn-pill mrn-pill-ghost"
                >
                  Check Airbnb →
                </a>
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
      <WhatsAppFAB />
      <ScrollToTop />
    </div>
  );
}
